import { PageController } from '@client/components/_core/layout/PageController';
import { CatastropheEventEdit } from '@client/components/claims/CatastropheEventEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/claims/catastrophe-events/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New catastrophe event',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <CatastropheEventEdit action={['add']} />
        </PageController>
    );
}
